/**
 * Crafted Dark Glass — homepage still hero + locked intro glass.
 * Mobile + desktop: static still, one glass card, sticky header, 1s sparkle.
 */
(function () {
  'use strict';

  var desktopMq = window.matchMedia('(min-width: 960px)');

  function getConfig() {
    return window.CraftedDarkGlassHome || {};
  }

  function prefersReducedMotion(cfg) {
    if (typeof cfg.reduceMotion === 'boolean') return cfg.reduceMotion;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSequence() {
    var cfg = getConfig();
    var root = document.getElementById('dgHomeSequence');
    if (!root || root.dataset.dgInitialized === 'true') return;
    root.dataset.dgInitialized = 'true';

    var pin = root.querySelector('#dgSequencePin') || root.querySelector('.sequence__pin');
    var benefitCards = Array.from(root.querySelectorAll('[data-benefit]'));
    var cta = root.querySelector('.sequence__cta') || root.querySelector('[data-dg-sequence-cta]');

    if (cfg.productUrl && cta) cta.setAttribute('href', cfg.productUrl);

    if (!pin) {
      if (window.CraftedMotion && typeof window.CraftedMotion.init === 'function') {
        window.CraftedMotion.init();
      }
      return;
    }

    var benefitTweens = [];
    var reduceMotion = prefersReducedMotion(cfg);

    function killScroll() {
      benefitTweens.forEach(function (t) {
        if (t.scrollTrigger) t.scrollTrigger.kill();
        t.kill();
      });
      benefitTweens = [];
      var seqClear = root.querySelector('.sequence') || root;
      if (seqClear && seqClear.style) seqClear.style.minHeight = '';
      root.classList.remove('dg-seq-mobile-static', 'dg-seq-desktop-static');
      document.body.classList.remove('dg-seq-header-pin', 'dg-seq-header-release', 'dg-seq-loading');
      document.documentElement.classList.remove('dg-seq-loading');
    }

    function initScroll() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        if (benefitCards[0]) benefitCards[0].style.opacity = '1';
        return;
      }

      gsap.registerPlugin(ScrollTrigger);
      /* iOS URL-bar resize refresh fights reverse scroll — ignore height-only resizes */
      if (typeof ScrollTrigger.config === 'function') {
        ScrollTrigger.config({ ignoreMobileResize: true });
      }
      killScroll();

      if (reduceMotion) {
        if (benefitCards[0]) gsap.set(benefitCards[0], { opacity: 1, yPercent: -50, y: 0 });
        benefitCards.slice(1).forEach(function (card) {
          gsap.set(card, { opacity: 0, visibility: 'hidden' });
        });
        return;
      }

      var sequenceEl = root.querySelector('.sequence') || root;
      var isMobile = !desktopMq.matches;

      function burstAppearFX(card) {
        if (reduceMotion || card.dataset.shining === '1') return;
        card.dataset.shining = '1';
        card.classList.remove('is-appearing');
        void card.offsetWidth;
        card.classList.add('is-appearing');

        window.clearTimeout(card._shineTimer);
        window.clearInterval(card._sparkleTimer);

        var layer = card.querySelector('.benefit-sparkles');
        var durationMs = 720;
        var shineFrom = 200;
        var shineTo = 560;
        var blueLeadPct = 0.48;

        function borderPointOutside(w, h, radiusPx, angleDeg, pad) {
          var rad = (angleDeg * Math.PI) / 180;
          var dx = Math.sin(rad);
          var dy = -Math.cos(rad);
          var hw = w / 2;
          var hh = h / 2;
          var rr = Math.min(radiusPx, hw, hh);
          var t;
          if (Math.abs(dx) < 1e-8) t = hh / Math.abs(dy);
          else if (Math.abs(dy) < 1e-8) t = hw / Math.abs(dx);
          else t = Math.min(hw / Math.abs(dx), hh / Math.abs(dy));

          var x = dx * t;
          var y = dy * t;
          var ix = hw - rr;
          var iy = hh - rr;
          var nx;
          var ny;

          if (Math.abs(x) > ix && Math.abs(y) > iy) {
            var cx = Math.sign(x) * ix;
            var cy = Math.sign(y) * iy;
            var cdot = cx * dx + cy * dy;
            var disc = cdot * cdot - (cx * cx + cy * cy - rr * rr);
            t = cdot + Math.sqrt(Math.max(0, disc));
            x = dx * t;
            y = dy * t;
            nx = (x - cx) / rr;
            ny = (y - cy) / rr;
          } else if (Math.abs(x) >= hw - 0.5) {
            nx = Math.sign(x);
            ny = 0;
            x = Math.sign(x) * hw;
          } else {
            nx = 0;
            ny = Math.sign(y);
            y = Math.sign(y) * hh;
          }

          return { x: hw + x + nx * pad, y: hh + y + ny * pad, nx: nx, ny: ny };
        }

        if (layer && window.gsap) {
          layer.innerHTML = '';
          var w = card.offsetWidth;
          var h = card.offsetHeight;
          var radiusPx = parseFloat(getComputedStyle(card).borderRadius) || 20;
          var layerPad = 28;
          var start = performance.now();
          var spawnEvery = 32;

          function spawnAtProgress(t) {
            var shineAngle = shineFrom + (shineTo - shineFrom) * t;
            var leadAngle = shineAngle + blueLeadPct * 360;
            var pad = 3 + Math.random() * 4;
            var p = borderPointOutside(w, h, radiusPx, leadAngle, pad);
            var left = p.x + layerPad;
            var top = p.y + layerPad;

            var spark = document.createElement('span');
            var roll = Math.random();
            spark.className =
              'benefit-sparkle' +
              (roll > 0.78 ? ' benefit-sparkle--lg' : '') +
              (roll < 0.22 ? ' benefit-sparkle--star' : '');
            spark.style.left = left + 'px';
            spark.style.top = top + 'px';
            layer.appendChild(spark);

            var out = 6 + Math.random() * 14;
            var driftX = p.nx * out + (Math.random() - 0.5) * 3;
            var driftY = p.ny * out + (Math.random() - 0.5) * 3;

            gsap.fromTo(
              spark,
              { opacity: 0, scale: 0.35, x: 0, y: 0 },
              {
                opacity: 0.95,
                scale: 0.85 + Math.random() * 0.45,
                x: driftX,
                y: driftY,
                duration: 0.22 + Math.random() * 0.18,
                ease: 'power2.out',
                onComplete: function () {
                  gsap.to(spark, {
                    opacity: 0,
                    scale: 0,
                    duration: 0.18,
                    ease: 'power1.in',
                    onComplete: function () {
                      spark.remove();
                    }
                  });
                }
              }
            );
          }

          spawnAtProgress(0);
          card._sparkleTimer = window.setInterval(function () {
            var t = (performance.now() - start) / durationMs;
            if (t >= 1) {
              window.clearInterval(card._sparkleTimer);
              return;
            }
            spawnAtProgress(Math.min(1, t));
            if (Math.random() > 0.55) spawnAtProgress(Math.min(1, t));
          }, spawnEvery);
        }

        card._shineTimer = window.setTimeout(function () {
          window.clearInterval(card._sparkleTimer);
          card.classList.remove('is-appearing');
          card.dataset.shining = '0';
        }, durationMs + 80);
      }

      function setupStaticHero(modeClass) {
        root.classList.add(modeClass);
        sequenceEl.style.minHeight = '';
        document.body.classList.add('dg-seq-header-pin');
        document.body.classList.remove('dg-seq-header-release');

        var headerGroup = document.getElementById('header-group');
        if (headerGroup) {
          document.body.style.setProperty('--header-group-height', headerGroup.offsetHeight + 'px');
        }

        benefitCards.forEach(function (card, i) {
          if (i === 0) {
            gsap.set(card, {
              clearProps: 'transform,top,left,right,x,y,xPercent,yPercent',
              opacity: 1,
              visibility: 'visible',
              display: ''
            });
          } else {
            gsap.set(card, {
              opacity: 0,
              visibility: 'hidden',
              display: 'none'
            });
          }
        });

        var sparkleDelay = window.setTimeout(function () {
          if (benefitCards[0] && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            burstAppearFX(benefitCards[0]);
          }
        }, 1000);
        benefitTweens.push({
          kill: function () {
            window.clearTimeout(sparkleDelay);
          },
          scrollTrigger: null
        });
      }

      /*
        Mobile + desktop: static still hero, one intro glass, sticky header.
        No scroll-scrub benefit bubbles (user request 2026-08-06).
      */
      if (isMobile) {
        setupStaticHero('dg-seq-mobile-static');
        return;
      }

      setupStaticHero('dg-seq-desktop-static');
    }

    initScroll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      /* Mobile URL-bar resize + ScrollTrigger.refresh causes fling jank */
      if (!desktopMq.matches) {
        var hg = document.getElementById('header-group');
        if (hg) {
          document.body.style.setProperty('--header-group-height', hg.offsetHeight + 'px');
        }
        return;
      }
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var hg = document.getElementById('header-group');
        if (hg) {
          document.body.style.setProperty('--header-group-height', hg.offsetHeight + 'px');
        }
      }, 80);
    });

    var lastMode = desktopMq.matches;
    function onBreakpointChange() {
      var now = desktopMq.matches;
      if (now === lastMode) return;
      lastMode = now;
      killScroll();
      initScroll();
    }
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', onBreakpointChange);
    else if (desktopMq.addListener) desktopMq.addListener(onBreakpointChange);

    if (window.CraftedMotion && typeof window.CraftedMotion.init === 'function') {
      window.CraftedMotion.init();
    }
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  window.CraftedDarkGlassHome = window.CraftedDarkGlassHome || {};
  window.CraftedDarkGlassHome.init = initSequence;

  onReady(function () {
    if (document.getElementById('dgHomeSequence')) initSequence();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target.querySelector('#dgHomeSequence')) return;
    var root = document.getElementById('dgHomeSequence');
    if (root) root.dataset.dgInitialized = 'false';
    initSequence();
  });
})();
